export default {
  slug: 'platform-overview',
  title: 'Platform overview',
  description: 'Architecture of cases, entities, links, and modules.',
  section: 'start',
  order: 2,
  tags: ['architecture', 'entities', 'modules'],
  body: `# Platform overview

Hivemind Subterfuge Platform combines **open-source intelligence enrichment** with **investigation case management** and **controlled engagement tooling** in one relational workspace.

## Design principles

- **Entity-centric** — cases, indicators, searches, personas, and evidence are first-class objects with detail pages, tabs, and pivot links.
- **Relational by default** — explicit \`EntityLink\` records plus implicit links (e.g. indicator ↔ case) power relationship tables and the investigation graph.
- **Investigator-safe** — audit logging, role-based access, and evidence quarantine are built in.

## Core entity types

| Entity | Description | Primary route |
|--------|-------------|---------------|
| **Case** | Investigation workspace with timeline, notes, IOCs, personas | \`/cases/:id\` |
| **Indicator** | Normalized observable (IP, domain, email, wallet, …) | \`/indicators/:id\` |
| **Search** | Intelligence enrichment run with JSON results | \`/intelligence/search/:id\` |
| **Persona** | Controlled identity used in engagement | \`/personas\` |
| **Evidence** | Quarantined artifact with scan metadata | \`/evidence\` |

## Module map

### Intelligence
In-house enrichment engine: IP/geo, DNS, WHOIS, panel fingerprints, phone carrier lookup, wallet tagging, and risk scoring. Supports async Celery jobs for long-running enrichment.

### Investigations
Case lifecycle, indicator registry, evidence vault, client reports, and immutable audit trail.

### Engagement
Personas, decoy assets (agents), intake endpoints (listeners), task workflows, analyst console, and artifact deploy — for authorized controlled engagement only.

## Relationship model

Links use typed relations such as:

- \`observed_in\` — indicator seen in a case
- \`promoted_from\` — indicator created from a search
- \`operated_by\` — persona tied to a case
- \`related_to\` — manual analyst link

The **[Investigation graph](/docs/relationships-graph)** visualizes these links and supports expand-on-click pivots.

## API access

Operator REST APIs are available under \`/api/\`. Swagger UI for schema exploration: \`/api/docs/\` (requires appropriate network access).
`,
};
